<template>
    <div>
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.material"
                        :request-query-string-params="autocompleteQueryStringParams.material"
                        :search-fields="autocompleteFields.material"
                        :validations="validations.material"
                        text-field="descricaoCompleta"
                        label="Material"
                        uppercase
                        v-model="model.material"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Estoque"
                        disabled
                        v-model="model.estoque"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Estoque máximo"
                        disabled
                        v-model="model.estoqueMaximo"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Permite requisitar"
                        disabled
                        v-model="model.permiteRequisitar"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.material || model.permiteRequisitar === 0"
                        :validations="validations.quantidade"
                        label="Quantidade"
                        number
                        v-model="model.quantidade"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :disabled="model.material && model.permiteRequisitar === 0"
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>
// Others.
import { mapActions } from 'vuex'
import { repository, error, object } from '@/mixins'

export default {
    computed: {
        autocompleteFields() {

            return {
                material: [
                    { key: 'cadastro_material.codigo_material', searchable: true },
                    { key: 'cadastro_material.descricao', searchable: true },
                ],
            }
        },
        autocompleteQueryStringParams() {

            return {
                material: {
                    allowed_to_request_to_centro_custo_id: this.data.model.centroCustoId,
                    with_estoque_greater_than_zero_to_centro_custo_id: this.data.additionals
                        .permiteRequisitarMateriaisSemEstoque ? null : this.data.model.centroCustoId,
                    with_requisicao_que_nao_concluiu_entrega_from_centro_custo_id: this.data.model.centroCustoId,
                    not_id: this.data.model.itens.map(i => i.material.id),
                }
            }
        },
        validations() {

            return {
                material: {
                    required: true,
                },
                quantidade: {
                    required: true,
                    max: 8,
                    min_value: 1,
                    max_value: this.model.estoqueMaximo !== null ? this.model.permiteRequisitar : 99999999,
                },
            }
        }
    },
    created() {

        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
            requisicao: this.getConectaSusRepository('almoxarifado.requisicaoAberturaFechamento'),
        }
    },
    data: () => ({
        model: {
            material: null,
            estoque: null,
            estoqueMaximo: null,
            permiteRequisitar: null,
            quantidade: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            const data = this.clone(this.model)

            this.data.model.itens.push({
                material: {
                    id: data.material.id,
                    codigo: data.material.codigoMaterial,
                    descricaoCompleta: data.material.descricaoCompleta,
                },
                quantidade: parseInt(this.model.quantidade),
            })

            this.resetForm()
        },
        resetForm() {

            this.model.material = null
            this.model.estoque = null
            this.model.estoqueMaximo = null
            this.model.permiteRequisitar = null
            this.model.quantidade = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        loadEstoque() {

            this.setLoading()

            this.repositories.requisicao.getEstoque(this.model.material.id, this.data.model.centroCustoId)
                .then(({ data }) => {

                    if(data.vencimento) {
                        this.showWarningNotification(`O material selecionado não pode ser requisitado, pois possui quantidade em estoque com vencimento nos próximo ${data.prazo} dia${data.prazo > 1 ? 's' : ''}`)
                        this.resetForm()
                        return
                    }

                    this.model.estoque = data.estoque
                    this.model.estoqueMaximo = data.estoqueMaximo
                    this.model.permiteRequisitar = data.permiteRequisitar
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'model.material': function (material) {

            if (!material) {

                this.model.estoque = null;
                this.model.estoqueMaximo = null;
                this.model.permiteRequisitar = null;
                this.model.quantidade = null;
            }
            else if (material.requisicaoQueNaoConcluiuEntrega) {

                this.showWarningNotification(`O material selecionado não poderá ser requisitado, pois possui quantidade
                    pendente de entrega na requisição de número ${material.requisicaoQueNaoConcluiuEntrega}.`)

                this.model.material = null
            }
            else {

                this.loadEstoque()
            }
        }
    }
}
</script>